import { vuexOidcProcessSilentSignInCallback } from 'vuex-oidc'
import { oidcSettings } from "@/config/oidc"
//console.log('oidc-silent-renew');
vuexOidcProcessSilentSignInCallback(oidcSettings);
